module.exports = ["messaging-success", "messaging-info", "messaging-warning", "messaging-error", "messaging-help"];